import { render, staticRenderFns } from "./no-data-message.vue?vue&type=template&id=bd542d52&"
import script from "./no-data-message.vue?vue&type=script&lang=js&"
export * from "./no-data-message.vue?vue&type=script&lang=js&"
import style0 from "./no-data-message.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd542d52')) {
      api.createRecord('bd542d52', component.options)
    } else {
      api.reload('bd542d52', component.options)
    }
    module.hot.accept("./no-data-message.vue?vue&type=template&id=bd542d52&", function () {
      api.rerender('bd542d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/no-data-message/no-data-message.vue"
export default component.exports